import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const STRIPE_PAYMENT_URL = process.env.REACT_APP_STRIPE_PAYMENT_URL || 'https://myeaitradingcompass.com/trading-subscription';

export default function FinalCTA({ onOpenModal }) {
  return (
    <section className="py-10 md:py-16 bg-white">
      <div className="mx-auto max-w-[1200px] px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="bg-gradient-to-br from-slate-50 to-blue-50 rounded-3xl border border-slate-200 shadow-lg p-8 md:p-12 lg:p-16 text-center"
        >
          <h2 
            data-testid="final-cta-heading"
            className="text-3xl md:text-4xl lg:text-5xl font-semibold text-[#337AF7] tracking-tight mb-6"
          >
            Stop Fixing Strategies. Fix Execution.
          </h2>
          
          <p className="text-base md:text-lg text-[#162959]/80 max-w-2xl mx-auto mb-8">
            Trading Compass sits between analysis and execution to enforce discipline, validate risk, and prevent impulsive decisions before money is at stake.
          </p>
          
          <a
            href={STRIPE_PAYMENT_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="final-cta-button"
            className="inline-flex items-center rounded-xl bg-[#337AF7] text-white font-semibold px-8 py-4 text-lg shadow-lg hover:bg-[#2563eb] hover:shadow-xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#337AF7]/50 transition-all duration-200"
          >
            Start 21-Day Challenge
            <ArrowRight className="ml-2 h-5 w-5" />
          </a>
          
          <p className="mt-6 text-xs md:text-sm text-[#162959]/50">
            Built for traders who want to manage capital responsibly.
          </p>
        </motion.div>
      </div>
    </section>
  );
}